export default __webpack_public_path__ + "static/banner-0d7e7305df1e0940261fe40968c131cb.jpg";